import React from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import * as StyledImageHero from './imageHero.styles';
import { withCropOptions } from '../../../helpers/images/withCropOptions';

const ImageHero = ({
	images
}) => {
	const galleryImages = images.map(image => ({
		original: `${withCropOptions(image).replace('{width}', '1920').replace('{height}', '0')}`,
		thumbnail: `${withCropOptions(image).replace('{width}', '300').replace('{height}', '0')}`
	}));

	return (
		<StyledImageHero.Wrapper>
			<ImageGallery
				items={galleryImages}
				thumbnailPosition="right" />
		</StyledImageHero.Wrapper>
	);
};

ImageHero.propTypes = {
	images: PropTypes.array
};

ImageHero.defaultProps = {
	images: ['/media/3905/ibud-banner.png', '/media/3906/stofa.png', '/media/3907/stofa-hvit.png', '/media/3908/svefnherbergi.png']
};

export default ImageHero;
